import React, { Component } from 'react'
import '../App.css'
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

import * as d3 from 'd3';

const styles = theme => ({
  container: {
    //backgroundColor: 'pink',

    width: '100%',
    height: '250px',

    [theme.breakpoints.down('xs')]: {
      height: '280px',
    },
    [theme.breakpoints.up('sm')]: {
      height: '320px',
    },
    [theme.breakpoints.up('md')]: {
      height: '221px',
    },
    [theme.breakpoints.up('lg')]: {
      height: '226px',
    },
    [theme.breakpoints.up('lg1660')]: {
      height: '250px',
    },
    [theme.breakpoints.up('xl')]: {
      height: '300px',
    },

    fontFamily: 'Flanders Art Sans!important',
  },
  bulletHeader: {
    fontSize: '0.9em',
    fontWeight: 700,
    textAlign: 'left',
    width: '100%',
    marginTop: 0,
    marginBottom: 0,
    paddingTop: "10px",
    paddingBottom: 12,
    paddingLeft: '5%',
  },
  bulletContainer: {
    //backgroundColor:'cyan',
    width: '100%',
    //height: '180px',
    [theme.breakpoints.down('xs')]: {
      height: '180px',
    },
    [theme.breakpoints.up('sm')]: {
      height: '220px',
    },
    [theme.breakpoints.up('tablet')]: {
      height: '280px',
    },
    [theme.breakpoints.up('md')]: {
      height: '145px',
    },
    [theme.breakpoints.up('lg')]: {
      height: '155px',
    },
    [theme.breakpoints.up('lg1660')]: {
      height: '200px',
    },
    [theme.breakpoints.up('xl')]: {
      height: '235px',
    },
  }
});

class BulletChart extends Component {
  state = {
    dataReady: false,
    componentUpdated: false,
    data: {
      solar: [],
      wind: [],
      windOffshore: [],
    },
    currentTech: {
      solar: true,
      wind: false,
      windOffshore: false,
    },
    currentMode: 'realtime',
    currentFilter: 'energy',
    currentDateTime: new Date().getTime(),

    maxValue: 100,

    hasForecast: false,
    hasMixedForecast: false,
  }

  componentDidUpdate() {
    if (this.props.dataReady) {
      if (!this.state.componentUpdated)
        this.updateChartData()
      else {
        let stateupdated = (
          //this.state.currentTech === this.state.currentTech
          JSON.stringify(this.state.currentTech) === JSON.stringify(this.state.currentTech)
          && this.props.currentMode === this.state.currentMode
          && this.props.currentFilter === this.state.currentFilter
          && this.props.currentDateTime === this.state.currentDateTime
          && this.props.data === this.state.data
        )
        if (!stateupdated) {
          this.setState({ componentUpdated: false })
        }
      }
    }
    else {
      if (this.state.componentUpdated) {
        this.setState({ componentUpdated: false })
      }
    }
  }

  updateChartData() {
    const maxValue = d3.max(this.props.data.demand_sums, function (t) {
      return t.value
    });
    //const maxValue = d3.max(Object.keys(this.props.data.demand_sums).map(key => this.props.data.demand_sums[key]));
    const name = 'Production'

    const actualDate = new Date();
    const currentSelectedDate = new Date(this.props.currentDateTime)
    const hasForecast = (currentSelectedDate.toDateString() === actualDate.toDateString() || currentSelectedDate.getTime() > actualDate.getTime())

    let hasMixedForecast = false
    if (hasForecast) {
      if (currentSelectedDate.toDateString() === actualDate.toDateString())
        hasMixedForecast = true
    }

    const currentDateTime = this.props.currentDateTime

    this.setState((previousState, props) => {
      return {
        dataReady: true,
        componentUpdated: true,
        currentDateTime: this.props.currentDateTime,
        currentTech: this.props.currentTech,
        currentMode: this.props.currentMode,
        currentFilter: this.props.currentFilter,

        data: this.props.data,
        maxValue: maxValue,
        activeStep: this.props.activeStep,
        hasForecast: hasForecast,
        hasMixedForecast: hasMixedForecast,
      };
    });
  }

  render() {
    const { classes } = this.props;

    if (!this.props.dataReady || !this.state.dataReady || !this.state.componentUpdated) {
      return (
        <div className={classes.chartDiv}>
          <CircularProgress className={classes.progress} size={50} />
        </div>
      )
    }
    //const solarColorArray = ['#fff292','#ffeb81','#ffe471','#ffdc5e','#ffd349','#ffcc33','#fbbb3b','#f7aa41','#f29945','#ed8749','#e8754c']
    //const windColorArray = ['#b8dadd','#afdadd','#a4dadd','#9ed9dd','#92d9dd','#86d9dd','#7ad8de','#6ed8de','#5cd8de','#41d8df','#06d8e0']

    let locale
    switch (this.props.lang) {
      case "de":
        locale = d3.timeFormatDefaultLocale({
          "decimal": ",",
          "thousands": ".",
          "grouping": [3],
          "currency": ["€", ""],
          "dateTime": "%a %b %e %X %Y",
          "date": "%d-%m-%Y",
          "time": "%H:%M:%S",
          "periods": ["AM", "PM"],
          "days": ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
          "shortDays": ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
          "months": ["", "Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
          "shortMonths": ["", "Jan", "", "Mar", "", "Mai", "", "Jul", "", "Sep", "", "Nov", ""]
        })
        break
      case "en":
        locale = d3.timeFormatDefaultLocale({
          "decimal": ",",
          "thousands": ".",
          "grouping": [3],
          "currency": ["€", ""],
          "dateTime": "%a %b %e %X %Y",
          "date": "%d-%m-%Y",
          "time": "%H:%M:%S",
          "periods": ["AM", "PM"],
          "days": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
          "shortDays": ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
          "months": ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
          "shortMonths": ["", "Jan", "", "Mar", "", "May", "", "Jul", "", "Sep", "", "Nov", ""]
        })
        break
      case "fr":
        locale = d3.timeFormatDefaultLocale({
          "decimal": ",",
          "thousands": ".",
          "grouping": [3],
          "currency": ["€", ""],
          "dateTime": "%a %b %e %X %Y",
          "date": "%d-%m-%Y",
          "time": "%H:%M:%S",
          "periods": ["AM", "PM"],
          "days": ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"],
          "shortDays": ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"],
          "months": ["", "janvier", "février", "mars", "avril", "mai", "juin", "juillet", "aôut", "septembre", "octobre", "novembre", "décembre"],
          "shortMonths": ["", "jan", "", "mar", "", "mai", "", "jui", "", "sep", "", "nov", ""]
        })
        break
      case "nl":
      default:
        locale = d3.timeFormatDefaultLocale({
          "decimal": ",",
          "thousands": ".",
          "grouping": [3],
          "currency": ["€", ""],
          "dateTime": "%a %b %e %X %Y",
          "date": "%d.%m.%Y",
          "time": "%H:%M:%S",
          "periods": ["AM", "PM"],
          "days": ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"],
          "shortDays": ["Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za"],
          "months": ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"],
          "shortMonths": ["Jan", "Feb", "Maa", "Apr", "Mei", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"]
        })
    }

    let energyType
    switch (this.props.lang) {
      case "de":
        energyType = (
          this.state.currentTech.solar ? (
            this.state.currentTech.wind ? (
              this.state.currentTech.windOffshore ?
                "Sonne und Wind onshore und offshore"
                : "Sonne und Wind onshore"
            )
              : (
                this.state.currentTech.windOffshore ?
                  "Sonne und Wind offshore"
                  : "Sonne"
              )
          )
            : (
              this.state.currentTech.wind ? (
                this.state.currentTech.windOffshore ?
                  "Wind onshore und offshore" :
                  "Wind onshore"
              )
                : "Wind offshore"
            )
        )
        break
      case "en":
        energyType = (
          this.state.currentTech.solar ? (
            this.state.currentTech.wind ? (
              this.state.currentTech.windOffshore ?
                "solar and wind onshore and offshore"
                : "solar and wind onshore"
            )
              : (
                this.state.currentTech.windOffshore ?
                  "solar and wind offshore"
                  : "solar"
              )
          )
            : (
              this.state.currentTech.wind ? (
                this.state.currentTech.windOffshore ?
                  "wind onshore and offshore" :
                  "wind onshore"
              )
                : "wind offshore"
            )
        )
        break
      case "nl":
      default:
        energyType = (
          this.state.currentTech.solar ? (
            this.state.currentTech.wind ? (
              this.state.currentTech.windOffshore ?
                "zon en wind onshore en offshore"
                : "zon en wind onshore"
            )
              : (
                this.state.currentTech.windOffshore ?
                  "zon en wind offshore"
                  : "zon"
              )
          )
            : (
              this.state.currentTech.wind ? (
                this.state.currentTech.windOffshore ?
                  "wind onshore en offshore" :
                  "wind onshore"
              )
                : "wind offshore"
            )
        )
    }


    //let dataNature
    //let technology
    let electricityDemand
    let technologyProduction
    let inh
    switch (this.props.lang) {
      case "de":
        //dataNature = (this.state.hasMixedForecast ? "observed and expected" : (this.state.hasForecast ? "expected" : "observed"))
        /*
        technology = (
          this.state.currentTech.solar ? (
            this.state.currentTech.wind ? (
              this.state.currentTech.windOffshore ?
                "Sonnenkollektoren und Windräder onshore und offshore"
                : "Sonnenkollektoren und Windräder onshore"
            )
              : (
                this.state.currentTech.windOffshore ?
                  "Sonnenkollektoren und Windräder offshore"
                  : "Sonnenkollektoren"
              )
          )
            : (
              this.state.currentTech.wind ? (
                this.state.currentTech.windOffshore ?
                  "Windräder onshore und offshore" :
                  "Windräder onshore"
              )
                : "Windräder offshore"
            )
        )
        */
        electricityDemand = "Strombedarf"
        technologyProduction = "Produktion " + energyType
        inh = "Einwohner"
        break
      case "en":
        //dataNature = (this.state.hasMixedForecast ? "observed and expected" : (this.state.hasForecast ? "expected" : "observed"))
        /*
        technology = (
          this.state.currentTech.solar ? (
            this.state.currentTech.wind ? (
              this.state.currentTech.windOffshore ?
                "solar panels and wind turbines onshore and offshore"
                : "solar panels and wind turbines onshore"
            )
              : (
                this.state.currentTech.windOffshore ?
                  "solar panels and wind turbines offshore"
                  : "solar panels"
              )
          )
            : (
              this.state.currentTech.wind ? (
                this.state.currentTech.windOffshore ?
                  "wind turbines onshore and offshore" :
                  "wind turbines onshore"
              )
                : "wind turbines offshore"
            )
        )
        */
        electricityDemand = "electricity demand"
        technologyProduction = energyType + " production"
        inh = "inhabitant"
        break;
      case "fr":
        //dataNature = (this.state.hasMixedForecast ? "observée et attendue" : (this.state.hasForecast ? "attendue" : "observée"))
        /*
        technology = (
          this.state.currentTech.solar ? (
            this.state.currentTech.wind ? (
              this.state.currentTech.windOffshore ?
                "panneaux solaires et turbines éoliennes onshore et offshore"
                : "panneaux solaires et turbines éoliennes onshore"
            )
              : (
                this.state.currentTech.windOffshore ?
                  "panneaux solaires et turbines éoliennes offshore"
                  : "panneaux solaires"
              )
          )
            : (
              this.state.currentTech.wind ? (
                this.state.currentTech.windOffshore ?
                  "turbines éoliennes onshore et offshore" :
                  "turbines éoliennes onshore"
              )
                : "turbines éoliennes offshore"
            )
        )
        */
        electricityDemand = "demande d'électricité"
        technologyProduction = "production " + energyType
        inh = "habitant"
        break
      case "nl":
      default:
        //dataNature = (this.state.hasMixedForecast ? "observée et attendue" : (this.state.hasForecast ? "attendue" : "observée"))
        /*
        technology = (
          this.state.currentTech.solar ? (
            this.state.currentTech.wind ? (
              this.state.currentTech.windOffshore ?
                "panneaux solaires et turbines éoliennes onshore et offshore"
                : "panneaux solaires et turbines éoliennes onshore"
            )
              : (
                this.state.currentTech.windOffshore ?
                  "panneaux solaires et turbines éoliennes offshore"
                  : "panneaux solaires"
              )
          )
            : (
              this.state.currentTech.wind ? (
                this.state.currentTech.windOffshore ?
                  "turbines éoliennes onshore et offshore" :
                  "turbines éoliennes onshore"
              )
                : "turbines éoliennes offshore"
            )
        )
        */
        electricityDemand = "elektriciteitsvraag"
        technologyProduction = "productie"
        inh = "inwoner"
    }

    const currentDateTime = this.props.currentDateTime
    const currentHour = currentDateTime.getHours()
    let currentDemand = this.state.data['demand_sums'].filter(obj => obj.datetime.getTime() === currentDateTime.getTime())[0].value
    //Object.keys(this.state.data['demand_sums']).forEach(datetime => {
    //  //if ((new Date(datetime)).getTime() === currentDateTime.getTime()) {
    //
    //    if (datetime.getTime() === currentDateTime.getTime()) {
    //    currentDemand = this.state.data['demand_sums'][datetime];
    //  }
    //});
    let currentProduction = this.state.data['sums'].filter(obj => obj.datetime.getTime() === currentDateTime.getTime())[0].value
    //Object.keys(this.state.data['sums']).forEach(datetime => {
    //  if ((new Date(datetime)).getTime() === currentDateTime.getTime()) {
    //    currentProduction = this.state.data['sums'][datetime];
    //  }
    //});
    let currentUnit

    let localeOption = this.props.lang === 'de' ? 'de-DE' : (this.props.lang === 'de' ? 'en-GB' : 'fr-BE');
    localeOption = 'nl-BE'

    const currentProductionPercentageFloat = (100 * currentProduction / currentDemand)
    const currentProductionPercentage = (100 * currentProduction / currentDemand).toLocaleString(localeOption, { minimumFractionDigits: 1, maximumFractionDigits: 1 })


    const enlargedMaxValue = 1.1 * this.state.maxValue
    const factor = 100 / (enlargedMaxValue)
    const productionDivHeight = factor * (enlargedMaxValue - currentProduction)
    const demandDivHeight = factor * (enlargedMaxValue - currentDemand)
    const productionBarHeight = (100 - productionDivHeight)

    switch (this.state.currentFilter) {

      case 'inhabitants':
        currentDemand = (currentDemand / 1000).toLocaleString(localeOption, { minimumFractionDigits: 0, maximumFractionDigits: 0 })
        currentProduction = (currentProduction / 1000).toLocaleString(localeOption, { minimumFractionDigits: 0, maximumFractionDigits: 0 })
        currentUnit = 'W/' + inh
        break;
      case "surface":
        currentDemand = (currentDemand / 1000).toLocaleString(localeOption, { minimumFractionDigits: 0, maximumFractionDigits: 0 })
        currentProduction = (currentProduction / 1000).toLocaleString(localeOption, { minimumFractionDigits: 0, maximumFractionDigits: 0 })
        currentUnit = 'MW/100 km\u00b2'
        break;
      case "energy":
      default:
        currentDemand = currentDemand.toLocaleString(localeOption, { minimumFractionDigits: 0, maximumFractionDigits: 0 })
        currentProduction = currentProduction.toLocaleString(localeOption, { minimumFractionDigits: 0, maximumFractionDigits: 0 })
        currentUnit = 'MW'


    }

    // against 3009x
    //let leftWidth = "69px"
    //let barWidth = "30px"
    //let innerBarWidth = "22.5px"
    //let rightWidth = "193.5px"
    let leftWidth = "23%"
    let barWidth = "10%"
    let innerBarWidth = "80%"
    let rightWidth = "65%"

    let bulletCommentFirstLine
    //let bulletCommentSecondLine
    switch (this.props.lang) {
      case "de":
        bulletCommentFirstLine = currentProductionPercentage + "% von der totalen Stromdarf "
        //bulletCommentSecondLine = "en Wallonia um " + currentHour + "h"
        break
      case "en":
        bulletCommentFirstLine = currentProductionPercentage + "% of the total electrical demand"
        //bulletCommentSecondLine = "in Wallonia at " + currentHour + "h"
        break
      case "fr":
        bulletCommentFirstLine = currentProductionPercentage + "% de la demande totale d'électricité"
        //bulletCommentSecondLine = "en Wallonie à " + currentHour + "h"
        break;
      case "nl":
      default:
        bulletCommentFirstLine = currentProductionPercentage + "% van de elektriciteitsvraag"
      //bulletCommentSecondLine = "in Vlaanderen om " + currentHour + "u"
    }

    let dividerColor = this.state.currentTech.solar ? (
      this.state.currentTech.wind ? "#00ff00" : (this.state.currentTech.windOffshore ? "#00ff00" : "#ffff00")
    )
      : "#00bfff"
    dividerColor = '#8b7f7e'

    let productionColor = this.state.currentTech.solar ? (this.state.currentTech.wind || this.state.currentTech.windOffshore ? "darkgreen" : "darkyellow") : (this.state.currentTech.wind ? "darkblue" : "brightblue")
    productionColor = 'darkgrey'
    let productionBackgroundColor = this.state.currentTech.solar ? (this.state.currentTech.wind || this.state.currentTech.windOffshore ? "bgdarkgreen" : "bgdarkyellow") : (this.state.currentTech.wind ? "bgdarkblue" : "bgbrightblue")

    return (
      <div className={classes.container}>
        <div className={classes.bulletHeader + " darkbluegreen"}>
          <div>{bulletCommentFirstLine}</div>
        </div>
        <div className={classes.bulletContainer}>
          <div style={{ width: leftWidth, float: 'left', height: '100%', position: "relative" }}>
            <div className={productionColor}
              style={{ position: "absolute", top: ((productionDivHeight - 8) + '%'), right: '5px' }}
            >
              {currentProductionPercentage} %
            </div>
          </div>
          <div style={{ width: barWidth, float: 'left', height: '100%' }}>
            {
              /*
              div style={{ width: '100%', height: (productionDivHeight + '%'),  borderBottomColor: dividerColor, borderBottomWidth: '3px', borderBottomStyle: 'solid', paddingLeft: '10%' }}>
                <div style={{ width: innerBarWidth, height: (100 * (demandDivHeight / productionDivHeight) + '%'), marginLeft: '10%;//5px' }}> </div>
                <div className="bgmediumgrey" style={{ width: innerBarWidth,  height: ((100 * (productionDivHeight - demandDivHeight) / productionDivHeight) + '%'), marginLeft: '10%;//5px' }}> </div>
              </div>
              */
            }
            <div
              style={{
                width: '100%',
                height: (demandDivHeight + '%'),
                borderBottomColor: dividerColor, borderBottomWidth: '3px', borderBottomStyle: 'solid',
                //paddingLeft: '10%'
              }}
            >
              <div
                style={{
                  width: innerBarWidth,
                  height: '100%',
                  marginLeft: '10%'
                }}
              > </div>
            </div>
            <div
              style={{
                width: '100%',
                height: (productionDivHeight - demandDivHeight + '%'),
                borderBottomColor: dividerColor, borderBottomWidth: '3px', borderBottomStyle: 'solid',
                //paddingLeft: '10%',
              }}>
              <div
                className="bgmediumgrey"
                style={{
                  width: innerBarWidth,
                  height: '100%',
                  marginLeft: '10%'
                }}
              > </div>
            </div>
            <div
              className={productionBackgroundColor}
              style={{
                width: innerBarWidth,
                height: (productionBarHeight + '%'),
                marginLeft: '10%'
              }}
            > </div>
          </div>
          <div className={productionColor} style={{ width: rightWidth, float: 'left', height: '100%', position: "relative" }}>
            <div
              style={{ position: "absolute", top: ((demandDivHeight - 8) + '%'), left: '5px', textAlign: 'left' }}
            >
              {currentDemand} {currentUnit} {electricityDemand}
            </div>
            <div className={productionColor}
              style={{ position: "absolute", top: ((currentProductionPercentageFloat > 80 ? '50%' : (productionDivHeight - 8) + '%')), left: '5px', textAlign: 'left' }}
            >
              {currentProduction} {currentUnit} {technologyProduction}
            </div>
          </div>
        </div>
        {
          this.props.windowWidth < 768 && (this.state.currentTech.wind || this.state.currentTech.windOffshore) && <div style={{marginTop:'20px'}}>
            <div className={'bgdarkgreen'} style={{minHeight:'14pt',minWidth:'14pt',border:'1px solid black', marginRight:'5px', display:'inline-block'}} />
            <div style={{display:'inline-block'}} >{energyType}</div>
          </div>
        }
      </div>
    )
  }
}

BulletChart.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(BulletChart)